export default __webpack_public_path__ + "static/media/02_DAIF_Services_05.f37ae8da.mp4";